<template lang="pug">
div(style="background-color: #00000059; z-index: 99; width: 100%; height: 100%; left: 0; top: 0; position: absolute;")
  .modal-box
    .head 合格投资者认证
    .main
      .tips
        p.strong 重要提示：
        p 在继续浏览本公司网站前，请您确认您或您所代表的机构是一名“私募基金合格投资者”。根据我国《私募投资基金监督管理暂行办法》的规定，私募基金合格投资者的标准如下：
      .content 
      | 一、具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人：
      | <br/>1、净资产不低于1000万元的单位；
      | <br/>2、个人金融资产不低于300万元或者最近三年个人年均收入不低于50万元。(前款所称金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。)
      | <br/>二、下列投资者视为合格投资者：
      | <br/>1、社会保障基金、企业年金、慈善基金；
      | <br/>2、依法设立并受国务院金融监督管理机构监管的投资计划；
      | <br/>3、投资于所管理私募基金的私募基金管理人及其从业人员；
      | <br/>4、中国证监会规定的其他投资者。
      | <br/>您若继续阅览本网站所载资料，将被视为您声明及保证为“私募基金合格投资者”，并将遵守相关法律法规的有关规定。
    .foot
      span.login(@click="$emit('confirm')") 登录认证
      span.quit(@click="$emit('cancel')") 放弃认证
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style scoped>
.modal-box {
  width: 50%;
  min-width: 800px;
  height: 600px;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255,255,255);
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  z-index: 99;
}

.modal-box .head {
  text-align: center;
  font-size: 1.1rem;
  padding: 20px 0;
  box-sizing: border-box;
  font-weight: 400;
  color: #D0121B;
  border-bottom: 1px solid #d4d4d4;
}

.modal-box .main .tips {
  padding: 8px 0;
  color: #D0121B;
  font-size: 0.9rem;
  line-height: 1.4;
  text-align: justify;
}

.strong {
  font-weight: 500;
}

.modal-box .main {
  height: 460px;
  text-align: justify;
  font-size: 0.9rem;
  line-height: 1.6;
  overflow-x: hidden;
  overflow-y: auto;
  /* overflow: scroll; */
}

.modal-box .foot {
  box-sizing: border-box;
  text-align: center;
  padding: 20px 0;
}

.modal-box .foot span {
  padding: 8px 40px;
  font-size: 0.84rem;
  color: white;
  cursor: pointer;
}

.modal-box .foot .login {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background-color: #D0121B;
}

.modal-box .foot .quit {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: #f36b2b;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/commons/Certification.vue